import request, { ResultHandler } from '@/core/utils/request'
import qs from 'qs'
const ShipmentBaseUrl = '/business/shipment'

export const createShipment = async body => {
  const result = await request({
    url: ShipmentBaseUrl,
    method: 'POST',
    data: body
  })
  return ResultHandler(result, 'Create shipment failed!') ?? null
}

export const queryShipment = async params => {
  const result = await request({
    url: ShipmentBaseUrl,
    method: 'GET',
    params,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Search shipment failed!') ?? []
}

export const detailShipment = async shipmentNo => {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmentNo,
    method: 'GET'
  })
  return ResultHandler(result, 'Detail shipment failed!') ?? null
}

export async function modifyShipment(shipmntNo, shipment) {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmntNo,
    method: 'PUT',
    data: shipment,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Modify shipment failed!') ?? null
}

export async function modifyShipmentPickUpInfo(shipmentId, pickUpInfo) {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmentId + '/pick',
    method: 'PUT',
    data: pickUpInfo,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
  return ResultHandler(result, 'Modify shipment failed!') ?? null
}

export async function deleteShipment(shipmentNo) {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmentNo,
    method: 'DELETE'
  })
  return ResultHandler(result, 'Delete shipment failed!')?.data ?? null
}

export async function changeTruckPort(shipmntId, dockNo, sameStagePort) {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmntId + '/port',
    method: 'POST',
    params: { dockNo, sameStagePort }
  })
  return ResultHandler(result, 'Modify shipment failed!') ?? null
}

export async function changeStageArea(shipmntId, stageId, forceChange) {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmntId + '/stage',
    method: 'POST',
    params: { stageId, forceChange }
  })
  return ResultHandler(result, 'Modify shipment failed!') ?? null
}

// export async function addPalletsToShipment(shipmntId, palletIds) {
//   const result = await request({
//     url: ShipmentBaseUrl + '/' + shipmntId + '/add',
//     method: 'POST',
//     data: palletIds
//   })
//   return ResultHandler(result, 'Modify shipment failed!') ?? null
// }

export async function modifyShipmentPallets(
  shipmentId,
  palletsAdd,
  palletsDelete
) {
  const result = await request({
    url: ShipmentBaseUrl + '/' + shipmentId + '/pallets',
    method: 'PUT',
    data: {
      palletsAdd,
      palletsDelete
    }
  })
  return ResultHandler(result, 'Modify shipment pallets failed!') ?? null
}
// export async function removePalletsFromShipment(shipmntId, palletIds) {
//   const result = await request({
//     url: ShipmentBaseUrl + '/' + shipmntId + '/remove',
//     method: 'POST',
//     data: palletIds
//   })
//   return ResultHandler(result, 'Modify shipment failed!') ?? null
// }

export async function shipmentInstruction(shipmentId) {
  const result = await request({
    url: ShipmentBaseUrl + `/${shipmentId}/instruction`,
    method: 'GET',
    responseType: 'blob'
  })
  return result
}

export async function readyShipment(readyDo) {
  const result = await request({
    url: ShipmentBaseUrl + `/${readyDo.id}/ready`,
    method: 'POST',
    data: readyDo
  })
  return ResultHandler(result, 'Ready shipment failed!') ?? null
}
